import { useEffect } from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { Phone } from "lucide-react";
import { COMPANY } from "../data/site";
import { Reveal } from "./Reveal";

export const Icon = ({ name, ...props }) => {
  const Cmp = Icons[name] || Icons.Package;
  return <Cmp {...props} />;
};

export const usePageMeta = (title, description) => {
  useEffect(() => {
    document.title = `${title} | CoreDock Logistics`;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (tag) tag.setAttribute("content", description);
    }
    window.scrollTo(0, 0);
  }, [title, description]);
};

export const Eyebrow = ({ children }) => <span className="tag-eyebrow">{children}</span>;

export const PageHero = ({ eyebrow, title, subtitle, image }) => (
  <section className="relative pt-[76px] bg-navy text-white overflow-hidden" data-testid="page-hero">
    <div className="absolute inset-0">
      <img src={image} alt="" className="w-full h-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-navy/70" />
    </div>
    <div className="relative max-w-[1440px] mx-auto px-6 md:px-12 py-24 md:py-36">
      <Reveal><Eyebrow>{eyebrow}</Eyebrow></Reveal>
      <Reveal delay={0.1}>
        <h1 className="font-display font-black uppercase tracking-tighter text-5xl md:text-6xl lg:text-7xl leading-[0.95] mt-4 max-w-4xl">
          {title}
        </h1>
      </Reveal>
      {subtitle && (
        <Reveal delay={0.2}>
          <p className="mt-6 text-lg text-white/70 max-w-2xl leading-relaxed">{subtitle}</p>
        </Reveal>
      )}
    </div>
  </section>
);

export const FinalCTA = () => (
  <section className="bg-orange text-navy" data-testid="final-cta">
    <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-20 md:py-28 grid lg:grid-cols-2 gap-10 items-center">
      <Reveal>
        <h2 className="font-display font-black uppercase tracking-tighter text-4xl md:text-5xl lg:text-6xl leading-[0.95]">
          Need Cross-Docking or Freight Support?
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="text-lg leading-relaxed text-navy/80">
          Tell us what you are moving, when it is arriving, and where it needs to go.
          Our team will respond with a practical logistics solution.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 mt-8">
          <Link to="/quote" data-testid="cta-quote"
                className="btn-navy px-8 py-4 font-semibold uppercase tracking-wide text-center">
            Request a Quote
          </Link>
          <a href={`tel:${COMPANY.phoneRaw}`} data-testid="cta-call"
             className="flex items-center justify-center gap-2 px-8 py-4 font-semibold uppercase tracking-wide border-2 border-navy hover:bg-navy hover:text-white transition-colors">
            <Phone size={18} /> Call Now
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
